// The order the contents are shown in: the operating year's phases, then admin.
// The server already sorts; this only groups, keeping its order.
export const SECTION_LABELS = {
  Start: "Start here",
  Sell: "Sell",
  Fill: "Fill",
  Build: "Build",
  Run: "Run",
  Close: "Close",
  Admin: "Admin",
};

/** [{ section, label, pages }] in the order the server listed them. */
export function groupBySection(contents) {
  const groups = [];
  const bySection = new Map();
  for (const page of contents || []) {
    let g = bySection.get(page.section);
    if (!g) {
      g = { section: page.section, label: SECTION_LABELS[page.section] || page.section, pages: [] };
      bySection.set(page.section, g);
      groups.push(g);
    }
    g.pages.push(page);
  }
  return groups;
}
